export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach((button) => {
			if (button.classList.contains("gform_button")) {
				return;
			}

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if (button.classList.contains('btn-go') || button.classList.contains('btn-back')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="127" height="42" viewBox="0 0 127 42" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M127 20.9629L126.894 21.0743L126.84 21.1326L107.19 42C104.914 40.663 102.649 39.3312 100.373 37.9942C104.441 33.7443 108.504 29.4944 112.567 25.2446H0V17.286H113.077C108.823 12.8717 104.569 8.4573 100.309 4.03765C102.58 2.69 104.84 1.34765 107.111 0L127 20.9629Z" fill="#FFDC00"/>
				</svg>`;
				element.classList.add('svg');
				button.prepend(element);
			}

			if (button.classList.contains('btn-download')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-gallery')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-lang')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

		});

	}

}
